import React, { useState } from 'react';
//import axios from 'axios';
import axiosInstance from '../axiosConfig'
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    // Reset the error message before submitting
    setError('');

    try {
      // Make a POST request to your backend to register the user
      await axiosInstance.post('/register', {
        username,
        password,
      });

      // After a successful registration, navigate to the login page
      navigate('/login');
    } catch (err) {
      console.error(err);
      setError('Error registering user. Please try again.');
    }
  };

  return (
    <div className="flex flex-col items-center p-4 max-w-md mx-auto bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-6">Register</h2>
      <form onSubmit={handleRegister} className="w-full">
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          className="border border-gray-300 rounded-md p-2 mb-4 w-full"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="border border-gray-300 rounded-md p-2 mb-4 w-full"
        />
        <button
          type="submit"
          className="bg-blue-500 text-white rounded-md p-2 w-full hover:bg-blue-600 w-full"
        >
          Register
        </button>
      </form>
      {error && (
        <p className="text-red-500 mt-4">
          {error}
        </p>
      )}
    </div>
  );
};

export default Register;